import { BOX_TYPES_MAP, MATERIAL_SLUG_MAP } from '../BoxTypes';

export function slugToLabel(slug) {
  if (!slug) return null
  const boxObject = unserializeSlug(slug)

  let name = boxObject.name
  let size = boxObject.size

  let label = `${name} ${size}`

  // if (boxObject.material) {
    // const formattedArray = [
    //   `Outside ${capitalize(boxObject.material.outside)}`,
    //   `Inside ${capitalize(boxObject.material.inside)}`,
    // ]

    // const materials = formattedArray.join(', ')

    // label = `${label} ${materials}`
  // }
  return label
}

export function slugToLabelWithUnits(slug) {
  if (!slug) return null
  const boxObject = unserializeSlugWithUnits(slug)

  let name = boxObject.name
  let size = boxObject.size

  let label = `${name} ${size}`

  // if (boxObject.material) {
    // const formattedArray = [
    //   `Outside ${capitalize(boxObject.material.outside)}`,
    //   `Inside ${capitalize(boxObject.material.inside)}`,
    // ]

    // const materials = formattedArray.join(', ')

    // label = `${label} ${materials}`
  // }
  return label
}

export function slugToMaterialColors(slug) {
  if(!slug) return null
  const materialMap = {
    w: 'white',
    k: 'kraft',
  }
  const materialCode = slug.split('-')[4] || 'kk'
  const outsideMaterial = materialMap[materialCode[0]];
  const insideMaterial = materialMap[materialCode[1]];
  return `Outside: ${outsideMaterial} | Inside: ${insideMaterial}`
}

function unserializeSlug(slug) {
  // Split the slug by '-'
  const parts = slug.split('-')

  const result = {}

  const boxTypeSlug = parts[0]
  const size = `${parts[1]}-${parts[2]}-${parts[3]}`

  result.name = BOX_TYPES_MAP[boxTypeSlug]
  result.type = boxTypeSlug
  result.size = unserializeSize(size)

  if (parts[4]) {
    result.material = MATERIAL_SLUG_MAP[parts[4]]
  }

  // console.log(result)
  return result
}

function unserializeSlugWithUnits(slug) {
  // Split the slug by '-'
  const parts = slug.split('-')

  const result = {}

  const boxTypeSlug = parts[0]
  const size = `${parts[1]}"-${parts[2]}"-${parts[3]}"`

  result.name = BOX_TYPES_MAP[boxTypeSlug]
  result.type = boxTypeSlug
  result.size = unserializeSize(size)

  if (parts[4]) {
    result.material = MATERIAL_SLUG_MAP[parts[4]]
  }

  // console.log(result)
  return result
}


// Greatest Common Divisor (GCD)
function gcd(a, b) {
  while (b !== 0) {
    const t = b
    b = a % b
    a = t
  }
  return a
}

function simplifyFraction(numerator, denominator) {
  const gcdValue = gcd(numerator, denominator)
  return [numerator / gcdValue, denominator / gcdValue]
}

function fractionPart(number) {
  if (number < 10) {
    number = number + '0'
  }

  let denominators = [2, 4, 8, 16]
  let decimal = number / 100

  for (let denominator of denominators) {
    let numerator = Math.round(decimal * denominator)
    if (Math.abs(decimal - numerator / denominator) < 0.01) {
      [numerator, denominator] = simplifyFraction(numerator, denominator)
      return `${numerator}/${denominator}`
    }
  }

  return `${number}/100`
}

function unserializeSize(input) {
  const dimensions = input.split('-')

  const formattedDimensions = dimensions.map((dim) => {
    dim = dim.replace(/_/g, ' ')

    return dim.replace(
      /(\d+) (\d{1,2})/g,
      (match, integerPart, fractionalPart) => {
        integerPart = parseInt(integerPart)
        fractionalPart = parseInt(fractionalPart)

        if (fractionalPart === 0) {
          return integerPart.toString() // If no fractional part, return integer
        }

        const fraction = fractionPart(fractionalPart)

        return `${integerPart} ${fraction}`
      }
    )
  })

  return formattedDimensions.join(' x ')
}



// function capitalize(str) {
//   return str.charAt(0).toUpperCase() + str.slice(1)
// }

// export default {slugToLabel, slugToLabelWithUnits}
